import {inject, singleton} from "tsyringe";
import {CommandHandler} from "../../decorators/command-handler.decorator";
import {Keyword} from "../../domain/entities/keyword.entity";
import {MessageBroker} from "../../message-broker/message-broker";
import {EntityDeletedPayload} from "../../message-broker/payloads/entity-deleted.payload";
import {CommandBus} from "../../services/command-bus.service";
import {DeleteKeywordCommand} from "../delete-keyword.command";
import {ICommand} from "../i-command.interface";
import {ICommandHandler} from "./i-command.handler";

@CommandHandler(DeleteKeywordCommand)
@singleton()
export class DeleteKeywordCommandHandler implements ICommandHandler<Keyword> {

    constructor(
        @inject(CommandBus) private readonly _commandBus: CommandBus,
        @inject(MessageBroker) private readonly _messageBroker: MessageBroker
    ) {
    }

    public async handle(command: ICommand<Keyword>): Promise<void> {
        if (!(await this._commandBus.addSendCommand(command))) {
            return;
        }

        // The command already carries the full entity as its payload; no re-fetch.
        const entity = command.payload;
        if (!entity) {
            console.error(`Es wurde kein Keyword mit der UUID ${command.mainEntityUid} in der Persistenz gefunden.`);
            return;
        }

        this._messageBroker.publish<EntityDeletedPayload<Keyword>>({
            type: `entity.deleted`,
            identityHash: command.mainEntityUid,
            payload: {entity}
        });
    }
}